<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <!-- {{user}} -->
           <!-- {{data}}
           {{ editInfo }} -->
          <h5 class="card-title">Información de Cliente No. {{ data.key_client }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{data.fullname}}</h6>
          <h6 class="card-subtitle mb-2 text-muted">{{data.status}}</h6>
          <div class="card mt-5">
            <div class="card-header row">
                <div class="col-lg-6">Información Básica</div>
                <div class="text-right col-lg-6">
                    <button class="btn btn-orange" @click="editarInfo">Editar</button>
                </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <h6>Nombre</h6>
                </div>
                <div class="col-md-2">
                  <h6>Email</h6>
                </div>
                <div class="col-md-2">
                  <h6>Teléfono</h6>
                </div>
                <div class="col-md-2">
                  <h6>Dirección</h6>
                </div>
                <div class="col-md-2">
                  <h6>Balance</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">{{ data.fullname }}</div>
                <div class="col-md-2">{{ data.email }}</div>
                <div class="col-md-2">{{ data.phone }}</div>
                <div class="col-md-2">{{ data.address }}</div>
                <div class="col-md-2">$ 0.00</div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Estado de cuenta
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-2">
                  <h6>Pedidos activos</h6>
                </div>
                <div class="col-md-2">
                  <h6>Total de Pedidos</h6>
                </div>
                <!-- <div class="col-md-2">
                  <h6>Notas de devolucion Activas</h6>
                </div>
                <div class="col-md-2">
                  <h6>Notas de credito Activas</h6>
                </div>
                <div class="col-md-2">
                  <h6>Notas de Ajuste</h6>
                </div> -->
              </div>
              <div class="row text-center">
                <div class="col-md-2">{{ ordenesActivas }} <br /><a href="#" @click="showDetails('comensales')">ver más</a ></div>
                <div class="col-md-2">$ {{ data.abonos }} <br /><a href="#" @click="showDetails('abonos')">ver más</a ></div>
                <!-- <div class="col-md-2">$ {{ data.abonos }} <br /><a href="#" @click="showDetails('abonos')">ver más</a ></div>
                <div class="col-md-2">{{ abonos.totalRecords }} <br /><a href="#" @click="$modal.show('showAbonos')">ver más</a ></div>
                <div class="col-md-2">{{ ajustes.totalRecords }} <br /><a href="#" @click="$modal.show('showAjustes')">ver más</a ></div> -->
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-header">
              Acciones rapidas
            </div>
            <div class="card-body">
               <!-- <button class="btn btn-purple mr-4" @click="AddOrder()">Realizar Pedido</button>
               <button class="btn btn-purple mr-4" @click="AddSales()">Generar Venta</button> -->
               <button class="btn btn-purple mr-4" @click="addDevolution()">Generar devolución</button>
               <button class="btn btn-purple mr-4" @click="modalAbono()">Generar abono</button>
               <button class="btn btn-purple mr-4" @click="modalAjuste()">Generar Ajuste</button>
               <button class="btn btn-orange mr-4" @click="goToTickets()">Detalle de vales</button>
               <!-- <button class="btn btn-success mr-4" @click="downloadExcel()">Descargar todos los Pedidos.</button> -->
                <div class="row justify-content-end">
                  <downloadexcel
                    class            = "btn btn-success"
                    :fetch           = "downloadExcelFn"
                    :fields          = "json_fields"
                    :name             = "'ORDENES CLIENTE ' + data.key_client + '.xls'">
                    Descargar todos los Pedidos.
                  </downloadexcel>
                </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Ordenes Activas
            </div>
            <div class="card-body">
              <vue-good-table
                mode="remote"
                :columns="columnsOrdersActive"
                :rows="orders"
                :row-style-class="rowStyleClassFn"
                :totalRows="cancelaciones.length"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
              >
              </vue-good-table>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Faltantes
            </div>
            <div class="card-body">
              <vue-good-table
                mode="remote"
                :columns="columnsOrders"
                :rows="faltantes"
                :row-style-class="rowStyleClassFn"
                :totalRows="cancelaciones.length"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <button class="btn" style="background: red; color: white; font-size: 12px;" @click="cancelarOrden(props.row)">Cancelar</button>
                  <button class=" ml-1 btn" style="background: blue; color: white; font-size: 12px;" @click="pedirOrden(props.row)">Volver a Pedir</button>
                </span>
              </template>
            </vue-good-table>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Devoluciones
            </div>
            <div class="card-body">
              <vue-good-table
                mode="remote"
                :columns="columnsOrders"
                :rows="devoluciones"
                :row-style-class="rowStyleClassFn"
                :totalRows="cancelaciones.length"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
            >
               <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <button class="btn" style="background: red; color: white; font-size: 12px;" @click="cancelarOrden(props.row)">Cancelar</button>
                  <button class=" ml-1 btn" style="background: blue; color: white; font-size: 12px;" @click="pedirOrden(props.row)">Volver a Pedir</button>
                  <button class=" ml-1 btn" style="background: green; color: white; font-size: 12px;" @click="reactivarVenta(props.row)">Reactivar</button>
                </span>
              </template>
            </vue-good-table>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-header">
              Cancelaciones
            </div>
            <div class="card-body">
              <vue-good-table
                mode="remote"
                :columns="columnsOrders"
                :rows="cancelaciones"
                :row-style-class="rowStyleClassFn"
                :totalRows="cancelaciones.length"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <button class="btn" style="background: red; color: white; font-size: 12px;" @click="reactivarVenta(props.row)">Reactivar Venta</button>
                  <button class=" ml-1 btn" style="background: blue; color: white; font-size: 12px;" @click="pedirOrden(props.row)">Volver a Pedir</button>
                </span>
              </template>
             <!-- <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'">
                  <b-dropdown id="dropdown-1" text="Acciones" class="m-md-2">
                    <b-dropdown-item @click="volverPedir(props)">
                      <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Pedir de Nuevo
                    </b-dropdown-item>
                    <b-dropdown-item @click="cancelarPedido(props)" style="background: red; color: white">
                      <font-awesome-icon :icon="['fa', 'shopping-cart']"/> Cancelar
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-if="props.column.field == 'cantidad'">
                  <input type="text" v-model="props.row.cantidad">
                </span>
                <span v-if="props.column.field == 'catalogo'">
                  <input type="text" v-model="props.row.catalogo">
                </span>
                <span v-if="props.column.field == 'marca'">
                  <input type="text" v-model="props.row.marca">
                </span>
                <span v-if="props.column.field == 'modelo'">
                  <input type="text" v-model="props.row.modelo">
                </span>
                <span v-if="props.column.field == 'color'">
                  <input type="text" v-model="props.row.color">
                </span>
                <span v-if="props.column.field == 'numero'">
                  <input type="text" v-model="props.row.numero">
                </span>
                <span v-if="props.column.field == 'product'">
                  {{props.row.product}}
                </span>
                <span v-if="props.column.field == 'delivery_date'">
                  <input type="text" v-model="props.row.delivery_date">
                </span>
              </template> -->
            </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="editInfo" :scrollable="true" height="750" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('editInfo')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h2 class="text-center">Editar Información</h2>
        <div class="form-group col-11">
           <label for="exampleInputEmail1">Número de Cliente</label>
           <input type="number" class="form-control ml-3" v-model="editInfo.key_client" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Número de cliente">
        </div>
        <div class="form-group col-11">
           <label for="exampleInputEmail1">Nombre</label>
           <input type="text" class="form-control ml-3" v-model="editInfo.name" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Nombre">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Appellido Paterno</label>
            <input type="text" class="form-control ml-3" v-model="editInfo.lastname1" placeholder="Apellido Paterno">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Appellido Materno</label>
            <input type="text" class="form-control ml-3" v-model="editInfo.lastname2" placeholder="Apellido Materno">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Dirección</label>
            <input type="text" class="form-control ml-3" v-model="editInfo.address" placeholder="Dirección">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Teléfono</label>
            <input type="phone" class="form-control ml-3" v-model="editInfo.phone" placeholder="Teléfono">
        </div>
        <div class="form-group col-11">
            <label for="exampleInputPassword1">Email</label>
            <input type="email" class="form-control ml-3" v-model="editInfo.email" placeholder="Email">
        </div>
        <div class="text-center">
            <button type="submit" class="btn btn-primary text-center" @click="updateInfo">Actualizar</button>
        </div>
      </div>
    </modal>
    <modal name="showAbonos" :scrollable="true" height="auto" width="800" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('showAbonos')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h3 class="text-center">Listado de abonos</h3>
        <b-card no-body>
          <b-tabs pills card>
            <b-tab title="Abonos disponibles" active>
              <div class="form-group row mt-4 justify-content-center">
                <vue-good-table
                  :columns="columnsAbonos"
                  :rows="abonos.disponibles"
                  :row-style-class="rowStyleClassFn"
                  :totalRows="abonos.totalRecords"
                  :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                  }"
                  styleClass="vgt-table bordered"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'print'">
                      <button class="btn btn-orange" @click="printAbono(props.row)">Imprimir</button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </b-tab>
            <b-tab title="Abonos utilizados">
              <div class="form-group row mt-4 justify-content-center">
                <vue-good-table
                  :columns="columnsAbonos"
                  :rows="abonos.utilizados"
                  :row-style-class="rowStyleClassFn"
                  :totalRows="abonos.totalRecords"
                  :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                  }"
                  styleClass="vgt-table bordered"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'print'">
                      <button class="btn btn-orange" @click="printAbono(props.row)">Imprimir</button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </modal>
    <modal name="showAjustes" :scrollable="true" height="auto" width="800" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('showAbonos')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h3 class="text-center">Listado de ajustes</h3>
        <div class="form-group row mt-4 justify-content-center">
          <vue-good-table
                mode="remote"
                :columns="columnsAbonos"
                :rows="abonos.rows"
                :row-style-class="rowStyleClassFn"
                :totalRows="abonos.totalRecords"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                styleClass="vgt-table bordered"
            >
             <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'print'">
                <button class="btn btn-orange" @click="printAbono(props.row)">Imprimir</button>
                </span>
              </template>
            </vue-good-table>
        </div>
      </div>
    </modal>
    <modal name="addAbono" :scrollable="true" height="300" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('addAbono')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h3 class="text-center">Generar Abono</h3>
         <div class="form-group row mt-4 justify-content-center">
          <label for="amountAbono" class="col-sm-3 text-center"><b>Monto:</b></label>
          <div class="col-sm-8">
            <input type="text" class="form-control" placeholder="$ 1000.00" id="amountAbono" v-model="montoAbono">
          </div>
           <label for="a¿descriptionAbono" class="col-sm-3 text-center mt-2"><b>Concepto:</b></label>
          <div class="col-sm-8 mt-2">
            <input type="text" class="form-control" placeholder="Descripción breve del concepto" id="a¿descriptionAbono" v-model="concepto">
          </div>
        </div>
        <div class="row justify-content-center text-center mt-5">
            <button type="submit" class="btn btn-primary text-center" @click="addAbono">Generar</button>
        </div>
      </div>
    </modal>
    <modal name="addAjuste" :scrollable="true" height="300" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('addAbono')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="reset-pass">
        <h3 class="text-center">Generar Ajuste</h3>
         <div class="form-group row mt-4 justify-content-center">
          <label for="amountAbono" class="col-sm-3 text-center"><b>Monto:</b></label>
          <div class="col-sm-8">
            <input type="text" class="form-control" placeholder="$ 1000.00" id="amountAbono" v-model="montoAjuste">
          </div>
           <label for="a¿descriptionAbono" class="col-sm-3 text-center mt-2"><b>Concepto:</b></label>
          <div class="col-sm-8 mt-2">
            <input type="text" class="form-control" placeholder="Descripción breve del concepto" id="a¿descriptionAbono" v-model="conceptoAjuste">
          </div>
        </div>
        <div class="row justify-content-center text-center mt-5">
            <button type="submit" class="btn btn-primary text-center" @click="addAJuste" :disabled="disableNewAjuste">Generar</button>
        </div>
      </div>
    </modal>
    <div class="mt-3">
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          filename = "hehehe.pdf"
          :paginate-elements-by-height="300"
          :pdf-quality="2"
          :manual-pagination="true"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          @beforeDownload="beforeDownload($event)"
          ref="html2Pdf"
        >
          <section slot="pdf-content" style="width: 75mm !important;">
            <div class="container ticket" style="width: 75mm !important">
              <div class="row mt-3 justify-content-center">
                <div class="col-lg-11 text-center line1">
                  <p>Mundo del catalogo</p>
                  <p>{{enterpriseData.name}}</p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 mt-1 text-center line1">
                  <p>Nota de Credito</p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 text-center" style="padding: 0px;">
                  <!-- <VueBarcode :value="abono.barcode" :options="barcode_option" format="CODE39"  textPosition="top" height="60" width="1" font-size="20" >
                    Show this if the rendering fails..
                  </VueBarcode> -->
                  <VueBarcode :value="abono.barcode" format="CODE128"  textPosition="top" :options="barcode_option" height="40" width="1.5" font-size="10"/>
                </div>
              </div>
              <div class="mt-2 bodyPrintAbono line1">
                <p><b>Cliente: </b></p>
                <p>{{abono.client_name}}</p>
                <p><b>Atendio: </b>{{abono.user_name}}</p>
                <div class="row justify-content-center mt-4" style="width: 75mm !important;">
                  <div class="col-lg-12">
                    <table class="tableXD" style="border: 1px solid;">
                      <tr>
                        <th>Descripción</th>
                        <th>Monto</th>
                        <th>Monto utilizado</th>
                        <th>Total disponible</th>
                      </tr>
                      <tr>
                        <td>{{abono.descripcion}}</td>
                        <td>$ {{abono.amount | formatNumberCurrency}}</td>
                        <td>$ {{abono.amount_use | formatNumberCurrency}}</td>
                        <td>$ {{abono.disponible | formatNumberCurrency}}</td>
                      </tr>
                      <tr>
                        <td colspan="3" style="text-align: right;">Total: </td>
                        <td>$ {{abono.disponible | formatNumberCurrency}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center mt-4">
                <div class="col-lg-10 text-center footerTicket">
                  <p>Gracias por su preferencia</p>
                  <p>Teléfonos</p>
                  <p v-for="(p, index) in footer.phones" :key="index">{{p.phone}}</p>
                </div>
              </div>
              <div class="row footerTicket mt-4">
                <div class="col-lg-10">
                  <p>{{footer.texto}}</p>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>
    </div>
    <div class="mt-3">
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          filename = "hehehe.pdf"
          :paginate-elements-by-height="300"
          :pdf-quality="2"
          :manual-pagination="true"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          @beforeDownload="beforeDownload($event)"
          ref="html2PdfAjuste"
        >
          <section slot="pdf-content" style="width: 75mm !important;">
            <div class="container ticket" style="width: 75mm !important">
              <div class="row mt-1 justify-content-center">
                <div class="col-lg-11 text-center line1">
                  <p>Mundo del catalogo</p>
                  <p>{{enterpriseData.name}}</p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 mt-1 text-center line1">
                  <p>Nota de Ajuste</p>
                </div>
              </div>
              <div class="row justify-content-left">
                <div class="col-lg-9 text-center">
                  <!-- <VueBarcode :value="ajuste.barcode" :options="barcode_option" format="CODE39"  textPosition="top" height="60" width="1" font-size="20" >
                  Show this if the rendering fails..
                </VueBarcode> -->
                <VueBarcode :value="ajuste.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="40" width="1" font-size="8"/>
                </div>
              </div>
              <div class="mt-2 bodyPrintAbono line1">
                <p><b>Cliente: </b></p>
                <p>{{ajuste.client_name}}</p>
                <p><b>Atendio: </b>{{ajuste.user_name}}</p>
                <div class="row justify-content-center mt-4" style="width: 75mm !important;">
                <!-- <div class="row justify-content-center mt-4 bodyPrintAbono line1" style="width: 70mm !important;"> -->
                  <div class="col-lg-12">
                    <!-- <table style="border: .5px solid #999; padding: 0px;" class="bodyLineHeigth"> -->
                    <table class="tableXD" style="border: 1px solid;">
                  <!-- <table class="tableXD"> -->
                    <tr>
                      <th>Descripción</th>
                      <th>Monto</th>
                      <th>Monto utilizado</th>
                      <th>Total disponible</th>
                    </tr>
                    <tr>
                      <td>{{ajuste.descripcion}}</td>
                      <td>$ {{ajuste.amount | formatNumberCurrency}}</td>
                      <td>$ {{ajuste.amount_use | formatNumberCurrency}}</td>
                      <td>$ {{ajuste.disponible | formatNumberCurrency}}</td>
                    </tr>
                    <tr>
                      <td colspan="3" style="text-align: right;">Total: </td>
                      <td>$ {{ajuste.disponible | formatNumberCurrency}}</td>
                    </tr>
                  </table>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center mt-4">
                <div class="col-lg-10 text-center footerTicket">
                  <p>Gracias por su preferencia</p>
                  <p>Teléfonos</p>
                  <p v-for="(p, index) in footer.phones" :key="index">{{p.phone}}</p>
                </div>
              </div>
              <div class="row footerTicket mt-4">
                <div class="col-lg-10">
                  <p>{{footer.texto}}</p>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>
    </div>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import downloadexcel from 'vue-json-excel'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable,
    VueHtml2pdf,
    VueBarcode,
    BCard,
    BTabs,
    BTab,
    downloadexcel
  },
  data () {
    return {
      json_fields: {
        Id: 'id_order',
        Catalogo: 'catalogo',
        Pagina: 'pagina',
        Comentarios: 'comentario',
        Marca: 'marca',
        Modelo: 'modelo',
        Color: 'color',
        Numero: 'numero',
        Precio: 'precio',
        '% Descuento Cliente': 'porcentaje_descuento',
        '% Descuento Tienda': 'porcentaje_descuento_nosotros',
        '$ Descuento Cliente': 'descuento',
        '$ Descuento Tienda': 'descuento_nosotros',
        'Precio de Venta': 'venta',
        'Precio de Compra': 'costo_tienda',
        Estatus: 'status',
        'Fecha de entrega': 'delivery_date',
        'Fecha de Registro': 'registration_date',
        Proveedor: 'name provider',
        'Codigo de barras': 'barcode',
        'Fecha de compra': 'date_buy'
      },
      disableNewAjuste: false,
      footer: {
        phones: [],
        texto: ''
      },
      enterpriseData: [],
      abono: [], // impresion de ticket+++
      ajustes: [], // impresion de ticket+++
      ajuste: [],
      abonos: [],
      barcode_option: {
        width: 1,
        height: 45
      },
      montoAbono: 0,
      montoAjuste: 0,
      concepto: '',
      conceptoAjuste: '',
      isLoading: false,
      devoluciones: [],
      ordenesActivas: 0,
      showComensales: false,
      showAbonos: false,
      showCargos: false,
      comensales: [],
      faltantes: [],
      orders: [],
      cancelaciones: [],
      data: [],
      contrato: '',
      titleModal: '',
      editInfo: {
        name: '',
        lastname1: '',
        lastname2: '',
        address: '',
        phone: '',
        email: '',
        key_client: 0
      },
      columnsAbonos: [
        {
          label: 'Codigo',
          field: 'barcode'
        },
        {
          label: 'Total abono',
          field: 'amount',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Total usado',
          field: 'amount_use',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Total disponible',
          field: 'disponible',
          formatFn: this.formatCurrencyX
        },
        {
          label: 'Imprimir',
          field: 'print'
        }
      ],
      columnsOrdersActive: [
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Proveedor',
          field: 'provider'
        },
        {
          label: 'Catalogo',
          field: 'catalogo'
        },
        {
          label: 'Pagina',
          field: 'pagina'
        },
        {
          label: 'Marca',
          field: 'marca'
        },
        {
          label: 'Modelo',
          field: 'modelo'
        },
        {
          label: 'Color',
          field: 'color'
        },
        {
          label: 'Talla',
          field: 'numero'
        },
        {
          label: 'Fecha',
          field: 'delivery_date'
        },
        {
          label: 'Estatus',
          field: 'status',
          tdClass: 'text-center'
        }
      ],
      columnsOrders: [
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Proveedor',
          field: 'provider'
        },
        {
          label: 'Catalogo',
          field: 'catalogo'
        },
        {
          label: 'Pagina',
          field: 'pagina'
        },
        {
          label: 'Marca',
          field: 'marca'
        },
        {
          label: 'Modelo',
          field: 'modelo'
        },
        {
          label: 'Color',
          field: 'color'
        },
        {
          label: 'Talla',
          field: 'numero'
        },
        {
          label: 'Fecha',
          field: 'delivery_date'
        },
        {
          label: 'Acciones',
          field: 'actions',
          tdClass: 'text-center'
        }
      ],
      htmlToPdfOptions: {
        margin: 0,
        // margin: 0,
        // image: {
        //   type: 'jpeg',
        //   quality: 0.98
        // },
        // enableLinks: false,
        html2canvas: {
          scale: 5,
          useCORS: true
        }
        // jsPDF: {
        //   unit: 'mm',
        //   format: 'b10',
        //   orientation: 'portrait'
        // }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    async downloadExcelFn () {
      const request = {
        id_client: this.data.key_client,
        enterprise_id: this.user.enterprise_id
      }
      const orders = await axiosAdelaService.post('/getAllOrdersForClient', request)
      console.log('orders para excel', orders.data.rows)
      return orders.data.rows
    },
    formatCurrencyX (val) {
      return '$ ' + this.$formatNumberCurrency(val)
    },
    rowStyleClassFn (row) {
      let color = ''
      if (row.encontrado === 1) {
        color = 'green'
      }
      if (row.otherClient === 1) {
        color = 'otherClient'
      }
      return color
    },
    addDevolution () {
      this.$router.push({ name: 'devolucionesCliente', params: { key_client: this.data.key_client } })
    },
    modalAbono () {
      this.$modal.show('addAbono')
    },
    modalAjuste () {
      this.$modal.show('addAjuste')
    },
    async addAbono () {
      try {
        this.disableNewAjuste = true
        const request = {
          key_client: this.data.key_client,
          amount: this.montoAbono,
          concepto: this.concepto,
          enterprise_id: this.user.enterprise_id,
          user_id: this.user.user_admin_id
        }
        const abonos = await axiosAdelaService.post('/addAbono', request)
        console.log('abonnos', abonos)
        if (abonos.status === 200) {
          this.$modal.hide('addAbono')
          this.$toastedPush({
            message: 'Abono generado correctamente',
            type: 'success'
          })
          this.abono = abonos.data
          await this.getAbonos()
          await this.printAbono()
          this.disableNewAjuste = false
          this.montoAbono = 0
          this.concepto = ''
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async addAJuste () {
      try {
        this.disableNewAjuste = true
        const request = {
          key_client: this.data.key_client,
          amount: this.montoAjuste,
          concepto: this.conceptoAjuste,
          enterprise_id: this.user.enterprise_id,
          user_id: this.user.user_admin_id
        }
        const abonos = await axiosAdelaService.post('/addAjuste', request)
        console.log('abonnos', abonos)
        if (abonos.status === 200) {
          this.$modal.hide('addAjuste')
          this.$toastedPush({
            message: 'Ajuste generado correctamente',
            type: 'success'
          })
          this.ajuste = abonos.data
          await this.getAjustes()
          await this.printAjuste()
          this.disableNewAjuste = false
          this.montoAjuste = 0
          this.conceptoAjuste = ''
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async printAbono (data) {
      console.log('imprimir abono', data)
      if (data !== undefined) {
        this.abono = data
      }
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
      }, 1000)
    },
    async printAjuste (data) {
      console.log('imprimir abono', data)
      if (data !== undefined) {
        this.abono = data
      }
      setTimeout(() => {
        this.$refs.html2PdfAjuste.generatePdf()
      }, 1000)
    },
    async getInfo () {
      try {
        const request = {
          id_client: this.data.id_client,
          enterprise_id: this.user.enterprise_id
        }
        const client = await axiosAdelaService.post('/getClient', request)
        console.log('GET CLIENT', client)
        // if (abonos.status === 200) {
        //   this.$modal.hide('editInfo')
        //   this.$toastedPush({
        //     message: 'Cliente actualizado',
        //     type: 'success'
        //   })
        this.data.fullname = client.data.rows.fullname
        this.data.lastname1 = client.data.rows.lastname1
        this.data.lastname2 = client.data.rows.lastname2
        this.data.phone = client.data.rows.phone
        this.data.address = client.data.rows.address
        this.data.emai = client.data.rows.email
        // }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async updateInfo () {
      try {
        const request = {
          name: this.editInfo.name,
          lastname1: this.editInfo.lastname1,
          lastname2: this.editInfo.lastname2,
          phone: this.editInfo.phone,
          address: this.editInfo.address,
          email: this.editInfo.email,
          key: this.editInfo.key_client,
          id_client: this.data.id_client
        }
        const abonos = await axiosAdelaService.post('/updateInfoClient', request)
        if (abonos.status === 200) {
          this.$modal.hide('editInfo')
          this.$toastedPush({
            message: 'Cliente actualizado',
            type: 'success'
          })
          this.getInfo()
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    showDetails (type) {
      this.$modal.show('details')
      switch (type) {
        case 'comensales':
          this.titleModal = 'Comensales'
          this.showComensales = true
          this.showAbonos = false
          this.showCargos = false
          break
        case 'abonos':
          this.titleModal = 'Abonos'
          this.showAbonos = true
          this.showCargos = false
          this.showComensales = false
          break
        case 'cargos':
          this.titleModal = 'Cargos'
          this.showAbonos = false
          this.showCargos = true
          this.showComensales = false
          break
        default:
          break
      }
    },
    async getDevolucionesClient () {
      try {
        const requestCargos = {
          id_client: this.data.key_client,
          enterprise_id: this.user.enterprise_id
        }
        const response = await axiosAdelaService.post('/getDevolucionesClient', requestCargos)
        console.log('canceled', response)
        if (response.status === 200) {
          console.log(response.data)
          this.devoluciones = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getOrdesCanceled () {
      try {
        const requestCargos = {
          id_client: this.data.key_client,
          enterprise_id: this.user.enterprise_id
        }
        const response = await axiosAdelaService.post('/getOrdesCanceled', requestCargos)
        console.log('canceled', response)
        if (response.status === 200) {
          console.log(response.data)
          this.cancelaciones = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getOrdesFaltantes () {
      try {
        this.faltantes = []
        const requestCargos = {
          id_client: this.data.key_client,
          enterprise_id: this.user.enterprise_id
        }
        const response = await axiosAdelaService.post('/getOrdesFaltantesClient', requestCargos)
        console.log('canceled', response)
        if (response.status === 200) {
          console.log(response.data)
          this.faltantes = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getAbonos () {
      try {
        const request = {
          id_client: this.data.key_client,
          enterprise_id: this.user.enterprise_id
        }
        const abonos = await axiosAdelaService.post('/getAbonos', request)
        console.log('***** getAbonos', abonos)
        if (abonos.status === 200) {
          this.abonos = abonos.data
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getAjustes () {
      try {
        const request = {
          id_client: this.data.key_client,
          enterprise_id: this.user.enterprise_id
        }
        const abonos = await axiosAdelaService.post('/getAjustes', request)
        console.log('getAbonos', abonos)
        if (abonos.status === 200) {
          this.ajustes = abonos.data
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getOrdersActives () {
      try {
        const request = {
          id_client: this.data.key_client,
          enterprise_id: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getOrdersActivesClient', request)
        console.log('getOrdersActivesClient', orders)
        if (orders.status === 200) {
          console.log(orders)
          this.orders = orders.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    AddOrder () {
      this.$router.push({ name: 'addOrders' })
    },
    AddSales () {
      this.$router.push({ name: 'addsales' })
    },
    editarInfo () {
      this.$modal.show('editInfo')
    },
    setPrint () {
      this.$router.push({ name: 'contractsPrint', params: { contrato: this.data.number } })
    },
    onProgress (progress) {
      this.progress = progress
      console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    hasDownloaded (blobPdf) {
      console.log('PDF has downloaded yehey')
      this.pdfDownloaded = true
      console.log(blobPdf)
    },
    async getCurrentEnterprise () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getEnterprisesSelected', request)
        console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.enterpriseData = orders.data.rows[0]
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async cancelarOrden (arg) {
      try {
        const request = {
          status: 3, // Status 3 Cancelado
          id_order: arg.id_order
        }
        const orders = await axiosAdelaService.post('/updateStatusOrder', request)
        if (orders.status === 200) {
          this.$toastedPush({
            message: 'Orden cancelada',
            type: 'success'
          })
          await this.getOrdesFaltantes()
          await this.getOrdesCanceled()
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async reactivarVenta (arg) {
      try {
        const request = {
          status: 5, // Status 3 Cancelado
          id_order: arg.id_order
        }
        const orders = await axiosAdelaService.post('/updateStatusOrder', request)
        if (orders.status === 200) {
          this.$toastedPush({
            message: 'Orden reactivada correctamente',
            type: 'success'
          })
          await this.getOrdersActives()
          await this.getOrdesCanceled()
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async pedirOrden (arg) {
      try {
        const request = {
          status: 1, // Status 3 Cancelado
          id_order: arg.id_order,
          amount: 1
        }
        const orders = await axiosAdelaService.post('/duplicateOrder', request)
        if (orders.status === 200) {
          this.$toastedPush({
            message: 'Orden cancelada',
            type: 'success'
          })
          await this.getOrdesFaltantes()
          await this.getOrdersActives()
          await this.getOrdesCanceled()
          await this.getOrdersActives()
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    async getFooterTicket () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id
        }
        const footer = await axiosAdelaService.post('/getFooterTicket', request)
        if (footer.status === 200) {
          console.log('footer', footer)
          this.footer.phones = footer.data.phones
          this.footer.texto = footer.data.textoFooter
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    goToTickets () {
      this.$router.push({ name: 'reportTickets', params: { client: this.$route.params.client } })
    }
  },
  watch: {
  },
  async mounted () {
    try {
      this.data = this.$route.params.client
      console.log('entro a esto', this.data)
      if (this.data === undefined) {
        this.$router.push({ name: 'client' })
      }
      this.editInfo.name = this.data.name
      this.editInfo.lastname1 = this.data.lastname1
      this.editInfo.lastname2 = this.data.lastname2
      this.editInfo.phone = this.data.phone
      this.editInfo.address = this.data.address
      this.editInfo.email = this.data.emai
      this.editInfo.key_client = this.data.key_client
      console.log('Parametros', this.$route.params)
      await this.getOrdersActives()
      await this.getOrdesCanceled()
      await this.getDevolucionesClient()
      await this.getOrdesFaltantes()
      await this.getAbonos()
      await this.getAjustes()
      await this.getCurrentEnterprise()
      await this.getFooterTicket()
    } catch (error) {
      this.showError('No se pudieron obtener los datos intentalo mas tarde.')
    }
  }
}
</script>

<style>
.footerTicket p {
  font-size: 8px;
  line-height: .1px !important;
}
.line1 p {
  font-family: 'Courier New', Courier, monospace;
  color: black;
  line-height: .1px !important;
  font-weight: bolder !important;
  font-size: 10px !important;
}
.bodyPrintAbono table {
  font-family: 'Courier New', Courier, monospace;
  color: black;
  font-size: 8;
  width: 100%;
}

.bodyPrintAbono td, th {
  /* border: 1px solid #dddddd; */
  text-align: left;
  padding: 8px;
}

.bodyPrintAbono tr:nth-child(even) {
  /* background-color: #dddddd; */
}
.ticket {
  font-family: 'Courier New', Courier, monospace;
  color: black;
  font-size: 10px;
}
.tableXD {
  font-family:Arial, Helvetica, sans-serif!important;
  font-weight: bolder !important;
  font-size: 10px !important;
}
</style>
